<div class="phone-input-wrap">
  <p-dropdown
    class="p-inputtext minContentDropdown"
    [options]="countryOptions"
    [placeholder]="placeholder"
    [(ngModel)]="selectedCountry"
    (ngModelChange)="onCountryCodeChange($event)"
    [ngModelOptions]="{standalone: true}"
    [filter]="true"
    filterBy="label,name,dial,value"
    [filterPlaceholder]="'Search country'"
    [disabled]="disabled"
    appendTo="body"
    name="selectCountryCode"
    [style]="{ width: '12rem' }"
    [panelStyle]="{ minWidth: '18rem' }">
    <ng-template let-item pTemplate="selectedItem">
      <span>{{ getSelectedCountryDisplay() }}</span>
    </ng-template>
    <ng-template let-item pTemplate="item">
      <span>{{ item.name }} {{ item.dial }}</span>
    </ng-template>
  </p-dropdown>
  <input
    type="tel"
    inputmode="numeric"
    pattern="[0-9]*"
    autocomplete="off"
    pInputText
    [maxlength]="nationalMaxLength"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [ngModel]="nationalInput"
    [ngModelOptions]="{standalone: true}"
    (ngModelChange)="onPhoneNumberChange($event)"
    (keypress)="allowOnlyDigits($event)"
    (paste)="onPasteDigits($event)"
    [ngClass]="{'input-invalidNumber': invalidNumber}" />
</div>
<div *ngIf="invalidNumber && (required || nationalInput)" class="errorShow" style="text-align: start; margin-top: 0px !important; margin-left: 24px !important;">
  {{ invalidMessage }}
</div>
